import { render } from "./EditConfig.vue?vue&type=template&id=4cd54bad&scoped=true"
import script from "./EditConfig.vue?vue&type=script&lang=js"
export * from "./EditConfig.vue?vue&type=script&lang=js"

import "./EditConfig.vue?vue&type=style&index=0&id=4cd54bad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd54bad"]])

export default __exports__